import styled from 'styled-components';

export const Container = styled.div`
  height: ${props => 78 + props.numberOfLinks * 47}px;
  max-height: ${props => 78 + props.max * 47}px;
  min-height: ${props => 78 + props.min * 47}px;
  width: 341px;
  background: var(--white-color);
  border: 1px solid #e5ebee;
  box-shadow: 0px 15px 40px rgba(11, 26, 33, 0.1);
  border-radius: 8px;

  ${props => {
    if (props.numberOfLinks > props.max) {
      return `&:after {
        border-radius: 8px;
        position: absolute;
        content: '';
        left: 6px;
        top: 59px;
        min-height: ${17 + props.min * 47}px;
        max-height: ${17 + props.max * 47}px;
        height: ${17 + props.numberOfLinks * 47}px;
        width: 94%;
        background: ${`${
          !props.scrollBottom
            ? 'linear-gradient(to bottom, rgba(255,255,255,0) 87%,rgba(255,255,255,1) 100%)'
            : ''
        }${!props.scrollBottom && !props.scrollTop ? ', ' : ''}${
          !props.scrollTop
            ? 'linear-gradient(to bottom, rgba(255,255,255,1) 0%,rgba(255,255,255,0) 13%)'
            : ''
        }`};
        pointer-events: none;
      }`;
    }
  }}
`;

export const Header = styled.div`
  padding: 20px 20px 13px 20px;
  border-bottom: 1px solid #cfd8dc;
  .toc--heading {
    margin: 0px;
    font-weight: 700;
  }
`;

export const Links = styled.div`
  border-radius: 8px;
  padding: 10px 0px;
  overflow-y: ${props => (props.numberOfLinks < props.max ? 'hidden' : 'auto')};
  overflow-x: hidden;
  min-height: ${props => 17 + props.min * 47}px;
  max-height: ${props => 17 + props.max * 47}px;
  height: ${props => 17 + props.numberOfLinks * 47}px;
  position: relative;
  background-color: var(--white-color);
  .toc--link-container {
    width: 100%;
    margin: 0px auto 0px 20px;
  }
  .toc--link-container:hover {
    background-color: var(--blue-1);
    margin: 0px auto 0px 6px;
    transition: 0.4s linear;
  }
  .toc--link {
    height: 47px;
    display: table;
    width: 100%;
    margin: 0px;
    white-space: nowrap;
    a {
      color: inherit;
    }
  }
  .toc--link:last-child {
    margin-bottom: 0px;
  }

  .active {
    color: var(--blue-5);
  }
  .toc--active-bar {
    position: absolute;
    left: 0;
    top: ${({ activeIndex }) => activeIndex * 47 + 10}px;
    height: 47px;
    width: 6px;
    background: #009ed6;
    transition: top 0.1s linear;
  }
`;
